module.exports = __webpack_public_path__ + "img/页宽+居右页码.f8a3a04b.jpg";